<template>
  <!-- Multi-root: одна <div> на каждую запись истории изменений, без обёртки. -->
  <div
    v-for="(text, i) in rows"
    :key="i"
    class="qtl-change-date"
    :class="{ 'qtl-change-date--grey': element.DisplayType === 6 }"
  >{{ text }}</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { TableDataCell } from "@/models/interfaces/entity-settings/querytable/querytable";
import { formatChangeDateRows } from "./cellFormat";

const props = defineProps<{ element: TableDataCell }>();
const rows = computed(() => formatChangeDateRows(props.element));
</script>

<style lang="scss" scoped>
.qtl-change-date {
  max-width: 100%;
  font-size: 13px;
  overflow-wrap: normal;
  word-break: normal;
  line-height: 1.2;
}

.qtl-change-date--grey {
  color: grey;
}
</style>
